export function normalizarNombreCategoria(valor) {
  return String(valor || '').trim();
}

export function categoriaEstaRegistrada(categorias, nombre) {
  const buscada = normalizarNombreCategoria(nombre).toLocaleLowerCase('es');
  if (!buscada) return false;
  return (Array.isArray(categorias) ? categorias : []).some(
    (categoria) => normalizarNombreCategoria(categoria?.nombre).toLocaleLowerCase('es') === buscada
  );
}

export function construirOpcionesCategorias(categorias, productos = [], categoriaActual = '') {
  const opciones = [];
  const vistos = new Set();

  const agregar = (nombre, extra = {}) => {
    const limpio = normalizarNombreCategoria(nombre);
    if (!limpio) return;
    const clave = limpio.toLocaleLowerCase('es');
    if (vistos.has(clave)) return;
    vistos.add(clave);
    opciones.push({ nombre: limpio, ...extra });
  };

  (Array.isArray(categorias) ? categorias : []).forEach((categoria) => {
    agregar(categoria?.nombre, { registrada: true, id: categoria?.id ?? null });
  });

  (Array.isArray(productos) ? productos : []).forEach((producto) => {
    const nombre = producto?.categoria || 'General';
    agregar(nombre, { registrada: categoriaEstaRegistrada(categorias, nombre), id: null });
  });

  if (categoriaActual) {
    agregar(categoriaActual, {
      registrada: categoriaEstaRegistrada(categorias, categoriaActual),
      id: null,
    });
  }

  return opciones.sort((a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' }));
}
